module.exports = __webpack_public_path__ + "media/images/information/function-8164c3e00f803444ca9764dd8ff88ee3.svg";